<template>
  <v-main id="cp">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title>Informations</v-card-title>
        <v-card-text>
          <p v-html="textePopup"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Fermer </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="autorise === true">
        <v-img
          src="@/assets/FIRSILOGO.png"
          contain
          max-height="50"
          max-width="150"
          class="mr-2"
        ></v-img>
      <div
      v-if="$storeConcours.DonneesFormulaire.ListeConcours.length < 1">
        <div style="min-height: 70vh" class="text-center">
          <v-card>
            <v-card-title class="justify-center"
              >Vous n'avez pas de concours</v-card-title
            >
          </v-card>
        </div>
      </div>
      <div v-else>
        <v-row class="text-right">
          <v-col cols="12">
            <v-btn
              x-large
              dark
              color="secondary"
              v-show="!$storeConcours.ReadOnly"
              @click.native="Enregistrer()"
            >
              Enregistrer</v-btn
            >
          </v-col>
        </v-row>
        <br />
        <v-alert
          type="info"
          color="secondary"
          v-show="
            !$storeConcours.ReadOnly &&
            $storeConcours.DonneesFormulaire.AfficherMessage
          "
        >
          Merci de renseigner vos résultats d’admissibilité sur chacune des
          écoles listées ci-dessous, puis cliquer sur "Enregistrer".
        </v-alert>
        <v-radio-group v-model="$storeConcours.DonneesFormulaire.EcoleRetenue">
          <!-- Début Liste langues -->
          <v-data-table
            :headers="headers"
            :items="$storeConcours.DonneesFormulaire.ListeConcours"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item="{ item }">
              <tr v-if="!item.Supprimer">
                <th v-show="item.FrancaisOuMarocain == 1" class="text-xs-left">
                  {{
                    $storeCatalogue.AffichageCatalogue(
                      $storeCatalogue.ConcoursFr,
                      item.ConcoursFrancais, $storeCommun.ItemLang
                    )
                  }}
                </th>
                <th v-show="item.FrancaisOuMarocain == 1" class="text-xs-left">
                  {{
                    $storeCatalogue.AffichageCatalogue(
                      $storeCatalogue.EcoleFr,
                      item.EcoleFrancaise, $storeCommun.ItemLang
                    )
                  }}
                </th>

                <th v-show="item.FrancaisOuMarocain == 2" class="text-xs-left">
                  {{
                    $storeCatalogue.AffichageCatalogue(
                      $storeCatalogue.ConcoursMa,
                      item.ConcoursMarocain, $storeCommun.ItemLang
                    )
                  }}
                </th>
                <th v-show="item.FrancaisOuMarocain == 2" class="text-xs-left">
                  {{
                    $storeCatalogue.AffichageCatalogue(
                      $storeCatalogue.EcoleMa,
                      item.EcoleMarocaine, $storeCommun.ItemLang
                    )
                  }}
                </th>
                <th>
                  <v-autocomplete
                    label="Admis à l'écrit"
                    v-model="item.AdmisEcrit"
                    item-text="lang00"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    @change="AdmissibleChange(item)"
                    :disabled="$storeConcours.ReadOnly"
                  ></v-autocomplete>
                </th>
                <th>
                  <v-autocomplete
                    label="Admissible à l'oral"
                    v-model="item.AdmisOral"
                    item-text="lang00"
                    item-value="id"
                    :items="$storeCatalogue.AdmissibleOral"
                    @change="AdmissibleChange(item)"
                    :disabled="$storeConcours.ReadOnly"
                  ></v-autocomplete>
                </th>
                <th>
                  <v-row>
                    <v-col cols="6">
                      <v-radio
                        label=""
                        :value="item.IdCrypte"
                        :disabled="
                          !ToutRenseigne() ||
                          item.AdmisEcrit != $storeCatalogue.DataId.Oui ||
                          item.AdmisOral !=
                            $storeCatalogue.DataId.AdmisOralOui ||
                          $storeConcours.ReadOnly
                        "
                      ></v-radio>
                    </v-col>
                    <v-col cols="6">
                      <v-icon
                        small
                        class="mr-2"
                        @click="clearRadio(item)"
                        v-show="
                          $storeConcours.DonneesFormulaire.EcoleRetenue ==
                            item.IdCrypte && !$storeConcours.ReadOnly
                        "
                        >{{ icons.mdiCloseCircleOutline }}</v-icon
                      >
                    </v-col>
                  </v-row>
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-radio-group>
      </div>
    </div>
    <NonAutorise v-else/>
  </v-main>
</template>
<script>
import NonAutorise from "@/components/PageNonAutoriseExtranet";
import { mdiCloseCircleOutline } from "@mdi/js";
export default {
  name: "Concours",
  components: {
    NonAutorise,
  },
  data() {
    return {
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiCloseCircleOutline,
      },
      loader: true,
      dialog: false,
      textePopup: null,
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeConcours: this.$storeConcours,
      $storeReglesBourse: this.$storeReglesBourse,
      $storeCommun:this.$storeCommun,
      erreur: null,
      token: null,
      autorise:false,
      // Catalogue local
      Concours: [
        {
          id: 1,
          lang00: "Français",
        },
        {
          id: 2,
          lang00: "Marocain",
        },
      ],

      // nom des colonnes
      headers: [
        { text: "Concours", value: "concours" },
        { text: "Ecole", value: "ecole" },
        { text: "Admissible à l'écrit", value: "ecrit" },
        { text: "Admissible à l'oral", value: "oral" },
        { text: "Ecole retenue", value: "retenue" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    document.title = "Concours";
  },

  mounted() {
    this.token = this.$route.query.t;
    let self = this;
    this.loader = true;
    if (this.token) {
      Promise.all([
        this.$storeCatalogue.ChargerCataloguesConcours(),
        this.$storeConcours
          .GetListeConcours(this.token)
          .then((response) => {
            if (response.status == 200 && response.data) {
              this.autorise = response.data.tokenValide;
              if (this.autorise === true) {
                this.$storeConcours.MapperDto(response.data);
                if (!response.data.ecoleRetenue &&
                  response.data.etatDossier &&
                  response.data.etatDossier !=
                    this.$storeCatalogue.DataId.BrouillonCandidat) {
                  this.$storeConcours.ReadOnly = false;
                }
              }
            }
          })
          .catch(function (error) {
            this.loader = false;
            if (error) {
              this.textePopup = "Une erreur est survenue";
              this.dialog = true;
            }
          }),
      ]).then(function () {
        self.loader = false;
        if (self.autorise === false){
          self.$router.push("/NonConnecte");
        }
      });
    } else {
      this.loader = false;
      this.$router.push("/NonConnecte");
    }
  },
  methods: {
    ToutRenseigne() {
      if (
        this.$storeConcours.DonneesFormulaire.ListeConcours.some(
          (v) => !v.AdmisEcrit
        )
      ) {
        return false;
      }
      if (
        this.$storeConcours.DonneesFormulaire.ListeConcours.some(
          (v) => !v.AdmisOral
        )
      ) {
        return false;
      }
      return true;
    },
    clearRadio(item) {
      if (
        item &&
        item.IdCrypte == this.$storeConcours.DonneesFormulaire.EcoleRetenue
      ) {
        this.$storeConcours.DonneesFormulaire.EcoleRetenue = null;
      }
    },
    Enregistrer() {
      var self = this;
      this.loader = true;
      this.token = this.$route.query.t;
      if (this.token) {
        Promise.all([
          this.$storeConcours
            .EnregistrerConcours(this.token)
            .then((response) => {
              this.$storeConcours.MapperDto(response.data);
              if (
                !response.data.ecoleRetenue &&
                response.data.etatDossier &&
                response.data.etatDossier !=
                  this.$storeCatalogue.DataId.BrouillonCandidat
              ) {
                this.$storeConcours.ReadOnly = false;
              }
            })
            .catch(function (error) {
              this.loader = false;
              if (error) {
                this.textePopup = "Une erreur est survenue";
                this.dialog = true;
              }
            }),
        ]).then(function () {
          self.loader = false;
        });
      } else {
        this.loader = false;
        this.autorise = false;
      }
    },
    AdmissibleChange(item) {
      if (
        !this.ToutRenseigne() ||
        (item.IdCrypte == this.$storeConcours.DonneesFormulaire.EcoleRetenue &&
          (item.AdmisEcrit != this.$storeCatalogue.DataId.Oui ||
            item.AdmisOral != this.$storeCatalogue.DataId.AdmisOralOui))
      ) {
        this.$storeConcours.DonneesFormulaire.EcoleRetenue = null;
      }
    },
  },
};
</script>
